var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect, useMemo } from 'react';
import { Box } from '@mui/material';
import ContainerPainel from '../container_painel';
import { BotaoAdicionar } from '../botoes';
import BarraPesquisar from '../grid_pesquisar';
import Grid, { PaginationModelDefault } from '../grid';
import { BoxPrincipal, BoxSuperior, BoxGrid } from '../grid_box';
import { useAuth } from '../../contexts/auth/AuthContext';
import { STATUS_API } from '../../api';
export var GridBase = function (_a) {
    var pagina = _a.pagina, _b = _a.rota, rota = _b === void 0 ? '' : _b, paginaPermissao = _a.paginaPermissao, fetchData = _a.fetchData, columns = _a.columns, _c = _a.usaPermissoes, usaPermissoes = _c === void 0 ? true : _c, _d = _a.hideAddButton, hideAddButton = _d === void 0 ? false : _d, rotaAdicionar = _a.rotaAdicionar, _e = _a.filtrosIniciais, filtrosIniciais = _e === void 0 ? {} : _e, renderFiltros = _a.renderFiltros, botoesSuperiorExtras = _a.botoesSuperiorExtras, opcaoAdicionalGrid = _a.opcaoAdicionalGrid, opcaoAdicionalInicioGrid = _a.opcaoAdicionalInicioGrid, botoesAcoesCustomizados = _a.botoesAcoesCustomizados, pagination = _a.pagination;
    var _f = useState(true), isLoading = _f[0], setIsLoading = _f[1];
    var _g = useState(''), textoBusca = _g[0], setTextoBusca = _g[1];
    var _h = useState(filtrosIniciais), filtros = _h[0], setFiltros = _h[1];
    var _j = useState([]), rows = _j[0], setRows = _j[1];
    var _k = useState(0), totalRegistros = _k[0], setTotalRegistros = _k[1];
    var _l = useState(__assign(__assign({}, PaginationModelDefault), pagination)), paginationModel = _l[0], setPaginationModel = _l[1];
    var getAcoesFuncionalidade = useAuth().getAcoesFuncionalidade;
    var acoesFuncionalidade = useMemo(function () {
        if (!usaPermissoes)
            return null;
        return getAcoesFuncionalidade(paginaPermissao || pagina);
    }, [getAcoesFuncionalidade, pagina, paginaPermissao, usaPermissoes]);
    var acoesHabilitadas = usaPermissoes ? acoesFuncionalidade : { CADASTRAR: true, VISUALIZAR: true, ALTERAR: true, EXCLUIR: true };
    useEffect(function () {
        carregarDados();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var carregarDados = function (busca, filtrosAtuais, pagModel) {
        if (busca === void 0) { busca = textoBusca; }
        if (filtrosAtuais === void 0) { filtrosAtuais = filtros; }
        if (pagModel === void 0) { pagModel = paginationModel; }
        return __awaiter(void 0, void 0, void 0, function () {
            var buscaFormatada, resposta;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setIsLoading(true);
                        buscaFormatada = busca === '' ? null : busca;
                        return [4 /*yield*/, fetchData(buscaFormatada, filtrosAtuais, pagModel)];
                    case 1:
                        resposta = _a.sent();
                        if ((resposta === null || resposta === void 0 ? void 0 : resposta.Status) === STATUS_API.ERRO) {
                            alert(resposta.Mensagem);
                        }
                        else if (resposta) {
                            setRows(resposta.dados || []);
                            setTotalRegistros(resposta.total_registros || 0);
                        }
                        setIsLoading(false);
                        return [2 /*return*/];
                }
            });
        });
    };
    var aoPesquisarTexto = function (texto) {
        var novoTexto = texto !== null && texto !== void 0 ? texto : '';
        setTextoBusca(novoTexto);
        var paginationAux = __assign(__assign({}, paginationModel), { page: 0 });
        setPaginationModel(paginationAux);
        carregarDados(novoTexto, filtros, paginationAux);
    };
    var atualizarFiltros = function (novosValores) {
        var novosFiltros = __assign(__assign({}, filtros), novosValores);
        setFiltros(novosFiltros);
        var paginationAux = __assign(__assign({}, paginationModel), { page: 0 });
        setPaginationModel(paginationAux);
        carregarDados(textoBusca, novosFiltros, paginationAux);
    };
    var onPaginationModelChange = function (novoModelo) {
        setPaginationModel(novoModelo);
        carregarDados(textoBusca, filtros, novoModelo);
    };
    var opcoesFuncionalidade = botoesAcoesCustomizados
        ? botoesAcoesCustomizados(acoesHabilitadas)
        : {
            ROTA: rota,
            VISUALIZAR: acoesFuncionalidade === null || acoesFuncionalidade === void 0 ? void 0 : acoesFuncionalidade['VISUALIZAR'],
            ALTERAR: acoesFuncionalidade === null || acoesFuncionalidade === void 0 ? void 0 : acoesFuncionalidade['ALTERAR'],
            EXCLUIR: acoesFuncionalidade === null || acoesFuncionalidade === void 0 ? void 0 : acoesFuncionalidade['EXCLUIR'],
        };
    var estadoBuscaCompleto = __assign({ textoBusca: textoBusca }, filtros);
    var colunasProtegidas = useMemo(function () { return __spreadArray([], columns, true); }, [columns]);
    return (_jsx(ContainerPainel, __assign({ pagina: pagina, pagina_especifica_permissao: paginaPermissao || pagina }, { children: _jsxs(BoxPrincipal, { children: [_jsxs(BoxSuperior, { children: [_jsx(BarraPesquisar, { filtrarGrid: aoPesquisarTexto }), !hideAddButton && _jsx(BotaoAdicionar, { pagina: rotaAdicionar || rota, disabled: usaPermissoes && !(acoesHabilitadas === null || acoesHabilitadas === void 0 ? void 0 : acoesHabilitadas['CADASTRAR']) }), botoesSuperiorExtras && botoesSuperiorExtras(estadoBuscaCompleto, acoesHabilitadas)] }), renderFiltros && _jsx(Box, __assign({ sx: { display: 'flex', flexDirection: 'row', flexWrap: 'wrap', mb: 2 } }, { children: renderFiltros(filtros, atualizarFiltros) })), _jsx(BoxGrid, { children: _jsx(Grid, { columns: colunasProtegidas, rows: rows, OPCOES_FUNCIONALIDADE: opcoesFuncionalidade, OPCAO_ADICIONAL: opcaoAdicionalGrid, OPCAO_ADICIONAL_INICIO: opcaoAdicionalInicioGrid, TotalRegistros: totalRegistros, isLoading: isLoading, PaginationModel: paginationModel, setPaginationModel: onPaginationModelChange }) })] }) })));
};
export default GridBase;
